/**
 * Section groupes du profil
 */
import { Tag } from '@carbon/react'
import { UserMultiple, CheckmarkFilled, Time } from '@carbon/icons-react'
import type { GroupMembershipDetail } from '@sphere/user/domain'
import { formatDateFrMonthYear } from '@sphere/shared/util'
import styles from './profile-groups.module.scss'

interface ProfileGroupsProps {
  groups: GroupMembershipDetail[]
}

export function ProfileGroups({ groups }: ProfileGroupsProps) {
  if (groups.length === 0) {
    return (
      <div className={styles.section}>
        <div className={styles.sectionHeader}>
          <h3 className={styles.sectionTitle}>
            <UserMultiple size={20} />
            Groupes
          </h3>
        </div>
        <p className={styles.empty}>Aucun groupe</p>
      </div>
    )
  }

  return (
    <div className={styles.section}>
      <div className={styles.sectionHeader}>
        <h3 className={styles.sectionTitle}>
          <UserMultiple size={20} />
          Groupes
          <Tag type="gray" className={styles.badge}>
            {groups.length}
          </Tag>
        </h3>
      </div>
      <div className={styles.items}>
        {groups.map(group => (
          <div
            key={group.membershipId}
            className={`${styles.item} ${!group.isActive ? styles.itemInactive : ''}`}
          >
            <div className={styles.itemHeader}>
              <div className={styles.itemContent}>
                <div className={styles.itemTitleRow}>
                  <h4 className={styles.itemTitle}>{group.groupName}</h4>
                  {group.isActive ? (
                    <CheckmarkFilled
                      size={16}
                      style={{ color: 'var(--cds-support-success)' }}
                    />
                  ) : (
                    <Time size={16} className={styles.itemMeta} />
                  )}
                </div>
                {group.originClass && (
                  <p className={styles.itemSubtitle}>
                    Classe d'origine: {group.originClass.name}
                  </p>
                )}
              </div>
            </div>
            <div className={styles.itemMeta}>
              Depuis {formatDateFrMonthYear(group.joinedAt)}
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
